





































import { DevTask } from '@/typescript/types'
import { Vue, Component } from 'vue-property-decorator'

@Component
export default class Development extends Vue {
  private tasks: DevTask[] = [
    { title: 'Story Mode Backend', status: 'done', next: true, subtitle: 'Story mode database schema and backend structure are implemented.' },
    { title: 'Story Mode Frontend', status: 'progress', next: true, subtitle: 'Story mode conversation UI, choices, and tracking are implemented.' },
    { title: 'Story Mode - Intro', status: 'progress', next: true, subtitle: 'The story intro is complete and integrated.' },
    { title: 'Story Mode - Chapter 1', status: 'todo', next: true, subtitle: 'Chapter 1 is released.' },
    { title: 'Balance Pass I', status: 'todo', subtitle: 'Weapons, armor, skills are tuned for balance.' },
    { title: 'PvP Reconnect', status: 'todo', subtitle: 'Players will have limited time to reconnect to resume play after disconnecting.' },
    { title: 'Paladin Class', status: 'todo', subtitle: 'Class design, assets, items, and mechanics are implemented.' },
    { title: 'Rogue Class', status: 'todo', subtitle: 'Class design, assets, items, and mechanics are implemented.' }
  ]

  private get tasksTodo (): DevTask[] {
    return this.tasks.filter(x => x.status === 'todo')
  }

  private get tasksProg (): DevTask[] {
    return this.tasks.filter(x => x.status === 'progress')
  }

  private get tasksDone (): DevTask[] {
    return this.tasks.filter(x => x.status === 'done')
  }
}
